var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAureaClogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 76.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b58154;}.cls-2{fill:#d5a366;}.cls-3,.cls-4{fill:#FFFFFF;}.cls-4{isolation:isolate;}.cls-4,.cls-5{opacity:.85;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Editavel"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m160.27,74.95h-.3v-1.42h.89v1.42l-.4,1.51h-.44l.25-1.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m118.51,72.48l.92-.34c.46,1.35,1.65,2.16,3.3,2.16s2.86-.85,2.86-2.24-.77-1.87-1.82-2.21l-2.24-.65c-1.62-.48-2.45-1.36-2.45-2.86,0-1.79,1.54-2.96,3.55-2.96,1.71,0,3.1.62,3.71,2.08l-.86.35c-.56-1.03-1.66-1.65-2.83-1.57-1.26,0-2.56.64-2.56,2,0,.95.46,1.65,1.97,2.1l2.24.65c1.34.38,2.29,1.22,2.29,2.96,0,1.9-1.52,3.24-3.92,3.24-2.08-.05-3.66-.99-4.16-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m128.88,63.57h4.17c2.3,0,3.97,1.33,3.97,3.73v3.85c0,2.4-1.73,3.82-3.97,3.82h-4.17v-11.41Zm4.11,10.51c1.94,0,3.03-1.26,3.03-2.86v-3.89c0-1.62-1.08-2.86-3.06-2.86h-3.07v9.61h3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m138.29,63.57h1.04l3.32,10.11h0l3.38-10.11h1.04l-3.94,11.47h-1.01l-3.84-11.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m148.92,63.57h1.25l3.78,6.96h0l3.71-6.96h1.28v11.41h-.99v-9.66h-.03l-3.58,6.59h-.8l-3.58-6.58h-.05v9.64h-.98v-11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m165.29,72.48l.93-.34c.46,1.35,1.62,2.16,3.29,2.16s2.86-.85,2.86-2.24-.77-1.87-1.82-2.21l-2.24-.65c-1.62-.48-2.44-1.36-2.44-2.86,0-1.79,1.54-2.96,3.55-2.96,1.71,0,3.1.62,3.71,2.08l-.86.35c-.55-1.03-1.66-1.65-2.83-1.57-1.26,0-2.56.64-2.56,2,0,.95.46,1.65,1.97,2.1l2.24.65c1.35.38,2.29,1.22,2.29,2.96,0,1.9-1.52,3.24-3.92,3.24-2.08-.05-3.66-.99-4.16-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m174.11,73.28h1.04v1.7h-1.04v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m188.96,73.28h1.04v1.7h-1.04v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m182.77,63.54h.96l4.19,11.44h-1.08l-1.25-3.61h-4.77l-1.31,3.6h-1.01l4.27-11.43Zm2.53,6.99l-2.06-5.79h0l-2.11,5.79h4.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.14,37.49V12.08c-.01-.15.1-.28.25-.3.01,0,.03,0,.04,0h4.03c.15,0,.29.11.3.26,0,.01,0,.02,0,.03v25.51c0,7.22,3.19,12.08,10.95,12.08s10.95-4.91,10.95-12.08V12.08c0-.15.11-.29.26-.3.01,0,.02,0,.03,0h4.02c.15,0,.29.11.3.26,0,.01,0,.02,0,.03v25.41c0,9.89-5.09,16.34-15.57,16.34s-15.57-6.45-15.57-16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m111.46,53.23h-4.79c-.15-.02-.28-.11-.36-.24l-7.82-17.64c-.98.12-1.97.18-2.96.18h-9.06v17.4c0,.15-.11.29-.26.3-.01,0-.02,0-.03,0h-4.02c-.15,0-.29-.11-.3-.26,0-.01,0-.02,0-.03V12.09c0-.15.11-.29.26-.3.01,0,.02,0,.03,0h13.51c8.41,0,14.15,3.73,14.15,11.78,0,5.45-2.61,8.94-6.87,10.66l8.7,18.64c.04.18-.02.36-.19.36Zm-6.63-29.66c0-5.27-3.19-7.81-9.35-7.81h-9v15.81h9c6.16,0,9.35-2.72,9.35-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m146.09,49.39v3.55c.01.15-.1.28-.25.3-.01,0-.03,0-.04,0h-26.7c-.15,0-.29-.11-.3-.26,0-.01,0-.02,0-.03V12.09c0-.15.11-.29.26-.3.01,0,.02,0,.03,0h26.54c.15,0,.29.11.3.26,0,.01,0,.02,0,.03v3.55c0,.15-.11.29-.26.3-.01,0-.02,0-.03,0h-22.22v13.81h19.71c.15,0,.29.11.3.26,0,.01,0,.02,0,.03v3.43c0,.15-.11.29-.26.3-.01,0-.02,0-.03,0h-19.71v15.33h22.38c.15,0,.28.11.29.26,0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m187.12,53.23h-4.79c-.18,0-.24-.12-.3-.24l-3.85-11.78h-18.59l-3.84,11.78c-.06.12-.12.24-.3.24h-4.79c-.18,0-.3-.12-.24-.36l13.79-40.84c.06-.12.12-.24.29-.24h8.7c.18,0,.24.12.3.24l13.85,40.84c.06.24-.06.36-.24.36Zm-10.24-16.1l-7.93-24.33h-.12l-7.94,24.33h15.98Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "38.86 53.37 25.92 21.76 19.43 37.62 25.88 53.37 38.86 53.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.43 5.91 12.94 21.76 19.43 37.62 25.92 21.76 19.43 5.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.82 0 28.31 15.85 34.8 0 21.82 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 53.37 12.98 53.37 19.43 37.62 12.94 21.76 0 53.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureaClogo);
export default __webpack_public_path__ + "static/media/AUREA_clogo.23c56eb985c6138d788324868922748d.svg";
export { ForwardRef as ReactComponent };